// extracted by mini-css-extract-plugin
export default {"component":"Directions_component__Z7IPI","card":"Directions_card__RnW7i","content":"Directions_content__QRV27"};